module.exports = __webpack_public_path__ + "static/media/how-rewards-work-step-1.4f8f0a79.jpg";